module.exports = __webpack_public_path__ + "static/img/5全荣.0e8ee40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/5全荣.jpg
// module id = AEfk
// module chunks = 1